export default __webpack_public_path__ + "static/media/search.5dd2c843.svg";